(ns ui.sticker-dialogs.quiz
  "The Replicant quiz sticker dialog: a question, two to four options
   and the correct one."
  (:require [clojure.string :as str]
            [storrito.editor.sticker-design :as sticker-design]
            [ui.sticker-dialogs.actions :as actions]
            [ui.sticker-dialogs.emoji-picker :as emoji-picker]
            [ui.sticker-dialogs.model :as model]
            [ui.sticker-dialogs.ui :as ui]))

(def sticker-shadow
  "0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12)")

(def correct-color
  "From Instagram."
  "#75c042")

(def tags
  ["A" "B" "C" "D"])

(defn px
  [size]
  (str size "px"))

(def question-id
  "sticker-quiz-question")

(defn initial-state
  [{:keys [data]}]
  {:question (or (:question data) "GUESS MY FAVORITE...")
   :options (model/quiz-options data)
   :correct_answer (or (:correct_answer data) 0)
   :start_background_color (or (:start_background_color data)
                               (get-in sticker-design/designs [:quiz-standard :gradient "0"]))
   :end_background_color (or (:end_background_color data)
                             (get-in sticker-design/designs [:quiz-standard :gradient "1"]))
   :text_color (or (:text_color data) "#ffffff")})

(defn submit-data
  [dialog]
  (when-let [data (model/valid-quiz dialog)]
    [:quiz-sticker "Quiz Sticker" data]))

(defn question-panel
  [dialog]
  (let [gradient (str/join "," (vals (get-in sticker-design/designs [:quiz-standard :gradient])))]
    [:div.relative.flex.items-center.justify-center.font-bold
     {:style {:word-break "break-word"
              :min-height (px 71)
              :max-height (px 102)
              :width "100%"
              :padding "16px"
              :border-top-left-radius (px 12)
              :border-top-right-radius (px 12)
              :background-image (str "linear-gradient(90deg, " gradient ")")}}
     [:div.relative
      (ui/text-field dialog
                     {:tag :textarea
                      :field :question
                      :dom-id question-id
                      :rows 2
                      :autofocus? true
                      :class ["block"]
                      :style {:word-break "break-word"
                              :border "hidden"
                              :width (px 350)
                              :font-size (px 26)
                              :line-height (px 34)
                              :font-family "AvenyT"
                              :text-align "center"
                              :color (:text_color dialog)
                              :resize "none"
                              :background-color "rgba(0,0,0,0)"}})
      (ui/emoji-button {:field :question
                        :dom-id question-id
                        :class (conj ui/emoji-button-inside-css "text-white")})]
     (emoji-picker/panel dialog :question)]))

(defn option-panel
  [dialog idx]
  (let [text (get-in dialog [:options idx])
        tag (get tags idx)
        dom-id (str "sticker-quiz-option-" idx)
        field [:options idx]
        correct? (= idx (:correct_answer dialog))]
    [:div.notranslate.relative.flex.items-center
     {:replicant/key idx
      :style {:background-color (when correct? correct-color)
              :user-select "none"
              :width (px 344)
              :height (px 64)
              :border-radius (px 33)
              :color "black"
              :border "2px solid lightgray"
              :margin-top (px 10)
              :margin-bottom (px 10)}}
     [:div.flex.cursor-pointer.justify-center.items-center.font-bold
      {:title "Mark as the correct answer"
       :style {:opacity (when (ui/blank? text) 0.2)
               :border-radius "30px"
               :margin (str "0px " (px 16))
               :min-width (px 32)
               :height (px 32)
               :border "2px solid black"}
       :on {:click [[:sticker-dialog/assoc :correct_answer idx]]}}
      tag]
     [:div.relative
      {:style {:opacity (when (ui/blank? text) 0.2)}}
      (ui/text-field dialog
                     {:tag :textarea
                      :field field
                      :dom-id dom-id
                      :rows 2
                      :style {:word-break "break-word"
                              :resize "none"
                              :font-size (px 20)
                              :font-family "Roboto"}})
      (ui/emoji-button {:field field
                        :dom-id dom-id
                        :class ui/emoji-button-inside-css})]
     (emoji-picker/panel dialog field)]))

(defn panel
  [dialog]
  (let [valid? (some? (model/valid-quiz dialog))]
    [:div.flex.flex-col
     {:style {:margin "20px"}}
     (ui/title "Start a Quiz" {:font-family "AvenyT"})
     [:form.m-0.flex.flex-col.items-center
      {:on {:submit [[:js/prevent-default]
                     [:sticker-dialog/submit]]}}
      [:div.relative.flex.flex-col.justify-between.items-center
       {:style {:box-shadow sticker-shadow
                :width (px 391)
                :min-height (px 269)
                :border-radius (px 12)}}
       (question-panel dialog)
       [:div.flex.flex-col
        {:style {:min-height (px 198)
                 :padding "11px 0"}}
        (map (partial option-panel dialog)
             (range (count (:options dialog))))]]
      [:span.mt-3.text-red-600
       "The presentation on Storrito will vary from the final post on Instagram."]
      [:div.mt-4.w-full.justify-center.flex
       (ui/primary-button {:type "submit"
                           :disabled (not valid?)}
                          "Add Quiz")]]]))

(defn render
  [state]
  (when-let [dialog (actions/dialog state)]
    (panel dialog)))

(def modal
  {:modal-id :modals/editor2-quiz-modal
   :on-load (fn [_state] [[:sticker-dialog/init :quiz]])
   :sticker/kind :quiz
   :sticker/single-asset-type :quiz-sticker
   :sticker/initial-state #'initial-state
   :sticker/submit-data #'submit-data
   :render #'render})

(def register
  [modal])
